import React, { useState } from "react";
import './account.css';
import {
    Button,
    Form,
    Col,
    Row,
    Container,
  } from "react-bootstrap";
import {useForm} from "react-hook-form";
import axios from 'axios';
import SyncLoader from "react-spinners/SyncLoader";
import GenericModal from '../../generic/modal';
import ReactGA from 'react-ga';

export default function Account(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const clinicData = props.location.state.clinicData;
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(Boolean);
    const {register, handleSubmit} = useForm();
    // let history = useHistory();
    
    const onSubmit = async (data) => {
        setLoading(true);
        data._id = props.location.state.clinicData._id;
        const token = localStorage.getItem('token');
        const axiosConfig = {
            headers: {
                Authorization: token
            }
        };
        await axios.post('https://uae-dentist-backend.herokuapp.com/account/clinic-profile', data, axiosConfig)
        .then(function (response) {
            console.log(response)
            setLoading(false);
            setSuccess(true);
            setShow(true);
        })
        .catch(function (error) {
            setSuccess(false);
            setShow(true);
            setLoading(false);
            console.log(error);
        })
    }
    
    return (
    <Container className="mt-5 rounded">
    { show && <GenericModal setShow={setShow} show={show} success={success}/>}
    <Row>
    <Col id="message" className="rounded p-5 mt-2 mb-2">
        Feel free to add as many clinics as you want.
        <br/>
        <br/>
        <h6>There will be more functionalities added soon. Feel free to give us feedback.
            <br/>
            <br/>
            Our simple service makes it easier for you to add information about your clinic - all around the clock. 
            Add your clinic today so that we can start showing it to customers.
            <br/>
            <br/>
            Welcome to AUE.dentist!
        </h6>
    </Col>
    <Col id="form" className="p-5 rounded">
    <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group >
            <Form.Label>Contact Person</Form.Label>
            <Form.Control placeholder={clinicData.contact_person} name="contact_person" ref={register ()}/>
        </Form.Group>

        <Form.Group controlId="role">
        <Form.Label>Role</Form.Label>
            <Form.Control placeholder={clinicData.role} as="select" name="role" ref={register ()} custom>
            <option disabled>- Please Select -</option>
            <option>Dentist/Owner</option>
            <option>Office Manager</option>
            <option>Front Desk Staff</option>
            <option>Admin Staff</option>
            <option>Other</option>
            </Form.Control>
        </Form.Group>

        {/* <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control placeholder={clinicData.email} type="email" name="email" ref={register ()} />
        </Form.Group> */}

        <Button variant="primary" type="submit">
            Update
        </Button>
        <div className='mt-5'>
          <SyncLoader
            size={15}
            margin={2}
            color={"#123abc"}
            loading={loading}
          />
        </div>
    </Form>
    
    </Col>
    </Row>
    
    </Container>
    )
}